module.exports = __webpack_public_path__ + "static/media/domuso-logo.a700c4e7.png";